import { Component } from '@angular/core';
import { FiscalSellerData } from '@modules/smart-api/models/fiscal-seller.model';
import { SmartImprFiscalPrinter } from '@modules/smart-api/models/smart-api.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'fina-fiscal-seller-registration',
    templateUrl: './fiscal-seller-registration.component.html',
})
export class FiscalSellerRegistrationComponent {
    availablePrinters: SmartImprFiscalPrinter[] = [];
    requireConfiguredPrinter = false;
    selectedPrinterKey = '';

    seller: FiscalSellerData = {
        codigo: '',
        nombre: '',
        numCajero: '',
    };

    constructor(public activeModal: NgbActiveModal) {}

    get hasConfiguredPrinters(): boolean {
        return this.availablePrinters.some(printer => printer.enabled !== false);
    }

    get shouldShowSupportMessage(): boolean {
        return this.requireConfiguredPrinter && !this.hasConfiguredPrinters;
    }

    get isValid(): boolean {
        if (this.shouldShowSupportMessage) return false;
        return !!this.seller.codigo?.trim() && !!this.seller.nombre?.trim() && !!this.seller.numCajero?.trim();
    }

    onPrinterChange(printerKey: string): void {
        this.selectedPrinterKey = printerKey;
        const printer = this.availablePrinters.find(candidate => (candidate.printerKey || candidate.numCajero) === printerKey);
        if (!printer) return;

        this.seller = {
            codigo: printer.codigo,
            nombre: printer.nombre,
            numCajero: printer.numCajero,
        };
    }

    save(): void {
        if (!this.isValid) return;

        this.activeModal.close({
            codigo: this.seller.codigo.trim(),
            nombre: this.seller.nombre.trim(),
            numCajero: this.seller.numCajero.trim(),
        });
    }
}
